import statistic from './statistic'

export default {
  settings: {
    isTimerDisabled: true,
    resetScoreOnPeriodChange: true,
    scoreInPoints: true,
    hasOvertime: false
  },
  actionTypes: {
    score: ['POINT', 'ADJUST_POINTS']
  },
  modules: {
    info: [
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      score: ingameData => ingameData.score,
      total: ingameData => ingameData.sets,
      meta: {
        dot: true
      }
    },
    fieldScheme: {
      component: 'match-center'
    },
    statistic,
    eventLog: {
      additionalPeriods: [{
        type: 'score',
        component: 'event-log-score',
        adjustEvents: ['ADJUST_POINTS', 'ADJUST_SETS']
      }]
    }
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    sets: {
      home: 0,
      away: 0
    }
  }
}
